// @ts-expect-error TS(7016) FIXME: Could not find a declaration file for module 'even... Remove this comment to see the full error message
import Events from 'event-pubsub/es6'

export default new Events()
